import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../redux/store/store";

export const handleEditIcd = (dispatch: AppDispatch, orderId: string) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.CLINICAL_DATA_TABLE,
      metaData: { orderId: orderId },
    }),
  );
};

/** Opens the Add Site NPI modal for the given order. */
export const handleEditSiteNpi = (dispatch: AppDispatch, orderId: string) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.ADD_SITE_NPI_MODAL,
      metaData: { orderId },
    }),
  );
};
